// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__R7qun","range":"MonthRangeSwitch_range__2Q3E1","disabled":"MonthRangeSwitch_disabled__1NyCp"};